import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PageHeader({ title, subtitle, icon: Icon, color = "#059669", right }) {
  const navigate = useNavigate();
  return (
    <div className="flex items-start gap-3 mb-6">
      <button
        onClick={() => navigate(-1)}
        data-testid="page-back"
        className="h-10 w-10 rounded-2xl bg-card border border-border flex items-center justify-center shrink-0 hover:bg-accent transition-colors"
        aria-label="Back"
      >
        <ArrowLeft className="h-5 w-5 text-foreground" />
      </button>
      {Icon && (
        <div className="h-10 w-10 rounded-2xl flex items-center justify-center shrink-0" style={{ backgroundColor: color + "1A" }}>
          <Icon className="h-5 w-5" style={{ color }} />
        </div>
      )}
      <div className="min-w-0 flex-1">
        <h1 className="text-2xl md:text-3xl font-semibold leading-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}
